import { configureStore } from "@reduxjs/toolkit";

import apiSlice from "./store-slices/apiSlice";
import searchSlice from "./store-slices/searchSlice";
import tilesSearchSlice from "./store-slices/tilesSearchSlice";

export const store = configureStore({
	reducer: {
		[apiSlice.reducerPath]: apiSlice.reducer,
		searchStore: searchSlice,
		tilesSearchStore: tilesSearchSlice,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(apiSlice.middleware),
	devTools: true,
});
